import BankStatementSampleModal from './bank-statement-sample-modal';

export default BankStatementSampleModal;